module.exports = __webpack_public_path__ + "img/IMG-20230301-WA0051.ff0d52ce.jpg";